<div class="flex flex-col gap-2">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h3 class="text-sm text-proffeo-text">{{ 'cooperations.groups-in-cooperation' | translate }}</h3>
    @if (writable() && canEditGroups()) {
      <proffeo-ui-button
        (clicked)="openAddGroupsDialog()"
        [text]="'cooperations.add-groups' | translate"
        variant="secondary"
        class="!py-1 !text-sm"
      ></proffeo-ui-button>
    }
  </div>
  @if (!cooperationGroups()?.length) {
    <div
      class="w-full overflow-hidden rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface px-4 py-6 text-center text-sm text-proffeo-disabled"
    >
      {{ 'cooperations.no-groups-in-cooperation' | translate }}
    </div>
  } @else {
    @if (writable()) {
      <div class="w-full overflow-hidden rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface">
        <div
          class="grid grid-cols-[minmax(0,1fr)_auto] items-center bg-proffeo-surface-muted px-4 py-2 text-xs text-proffeo-muted"
        >
          <span>{{ 'cooperations.groups-table.columns.group' | translate }}</span>
          <span class="text-right">{{ 'cooperations.groups-table.columns.actions' | translate }}</span>
        </div>
        <ul class="divide-y divide-proffeo-border text-sm text-proffeo-text">
          @for (cg of cooperationGroups(); track cg.id) {
            <li class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2 px-4 py-2">
              <span class="truncate">{{ cg.group()?.name ?? '—' }}</span>
              @if (canEditGroups() && cg.group()?.id) {
                <proffeo-ui-button
                  (clicked)="removeGroup(cg.group()!.id)"
                  variant="ghost"
                  text="cooperations.remove-group"
                  class="justify-self-end !text-xs text-proffeo-danger hover:underline"
                />
              }
            </li>
          }
        </ul>
      </div>
    } @else {
      <div class="w-full overflow-hidden rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface">
        <div class="bg-proffeo-surface-muted px-4 py-2 text-xs text-proffeo-muted">
          {{ 'cooperations.groups-table.columns.group' | translate }}
        </div>
        <ul class="divide-y divide-proffeo-border text-sm text-proffeo-text">
          @for (cg of cooperationGroups(); track cg.id) {
            <li class="px-4 py-2">
              <span class="truncate">{{ cg.group()?.name ?? '—' }}</span>
            </li>
          }
        </ul>
      </div>
    }
  }
</div>
